import { cn } from '@/utils/utils';
import React from 'react';

interface ModalReactProps {
    isOpen: boolean,
    onClose?: () => void,
    content?: React.ReactNode,
    className?: string
}

const ModalReact: React.FC<ModalReactProps> = ({ isOpen, onClose = () => {}, content, className = '' }) => {
    if (!isOpen) return null;

    return (
        <div className={cn('absolute top-0 left-0 w-full h-full bg-black/50 z-50', className)}>
            {content && <div className='mt-2'>{content}</div>}
        </div>
    );
};

export default ModalReact;
